import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UssdTransactionsPage } from './ussd-transactions';

@NgModule({
  declarations: [
    UssdTransactionsPage,
  ],
  imports: [
    IonicPageModule.forChild(UssdTransactionsPage),
  ],
})
export class UssdTransactionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/ussd-transactions/ussd-transactions.module.ts